export class Line {
  constructor (partNumber, quantity) {
    this.partNumber = partNumber;

    if (typeof quantity === 'string') {
      // Sanitize thousand separator
      this.quantity = Number(quantity.replace('.', '').replace(',', '.'))
    } else {
      this.quantity = quantity;
    }
  }

  partNumber = '';
  quantity = null;
  errors = [];
  part = null;
}